import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import SearchResult from './SearchResult'

const selector = createStructuredSelector({})

const actions = {}

export default connect(selector, actions)(SearchResult)
